export default {
  data: () => ({
    isShown: true,
  }),
  mounted() {
  },
  methods: {
    closeAlert() {
      this.$http
        .get('api/v1/close-alert')
        .then(response => {
          this.isShown = false
        })
        .catch(error => {
          this.isShown = true
        })
    }
  }
}
